import { render, staticRenderFns } from "./PurchaseRequestDetail.vue?vue&type=template&id=031108fc&scoped=true"
import script from "./PurchaseRequestDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseRequestDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchaseRequestDetail.vue?vue&type=style&index=0&id=031108fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031108fc",
  null
  
)

export default component.exports